module.exports = __webpack_public_path__ + "assets/img/650400.1b1da0f1.png";